import { comment, post, profile } from '@/api'

import {
	POST_ADD,
	POST_ADD_ERROR,

	POST_COMMENT_ADD,
	POST_COMMENT_ADD_ERROR,
	POST_COMMENT_ADD_STATUS,

	POST_COMMENT_DELETE,
	POST_COMMENT_DELETE_ERROR,
	POST_COMMENT_DELETE_STATUS,

	POST_COMMENT_REPLY,
	POST_COMMENT_REPLY_ERROR,
	POST_COMMENT_REPLY_STATUS,

	POST_COMMENT_REPLY_DELETE,
	POST_COMMENT_REPLY_DELETE_ERROR,
	POST_COMMENT_REPLY_DELETE_STATUS,

	POST_COMMENT_UPDATE,
	POST_COMMENT_UPDATE_ERROR,
	POST_COMMENT_UPDATE_STATUS,

	POST_DELETE,
	POST_DELETE_ERROR,

	POST_EVENT_COMMENT_ADD,
	POST_EVENT_COMMENT_ADD_ERROR,
	POST_EVENT_COMMENT_ADD_STATUS,

	POST_FEATURED_GET,
	POST_FEATURED_LOADING,
	POST_FILE_LOADING_STATUS,

	POST_GET,
	POST_GET_ERROR,

	POST_COMMENTS_GET,
	POST_COMMENTS_GET_ERROR,

	POST_LOADING_STATUS,

	POST_REPORT,
	POST_REPORT_ERROR,
	POST_REPORT_STATUS,

	POST_UPDATE,
	POST_UPDATE_ERROR,
	POST_UPLOAD_FILE,

	POST_VIOLATIONS_GET,
	POST_VIOLATIONS_GET_ERROR,

	POSTS_FETCH,
	POSTS_FETCH_BY_AUTHOR,
	POSTS_FETCH_BY_AUTHOR_ERROR,
	POSTS_FETCH_BY_CATEGORY,
	POSTS_FETCH_BY_CATEGORY_ERROR,
	POSTS_FETCH_ERROR,

	POST_COMMENT_LIKE,
	POST_COMMENT_LIKE_ERROR,

	POSTS_NEARBY_FETCH,
	POSTS_NEARBY_FETCH_ERROR,
	POSTS_NEARBY_FETCH_LOADING,
	POST_GET_ERROR_NOT_FOUND,

	POST_POLL_VOTING,
	POST_POLL_VOTING_ERROR,
	POST_POLL_LIST_UPDATE,
	POST_UPDATE_STATUS,

	POST_POLL_TIMER,
	POST_POLL_TIMER_LOADING,

	POST_POLL_USERS_LOADING,
	POST_POLL_USERS,
	POST_POLL_STOP,

	POST_VIDEO_PREVIEW,
	POST_VIDEO_PREVIEW_LOADING,
	POST_VIDEO_PREVIEW_ERROR
} from './types'

import {
	FORUM_COMMENT_LIKE,
	FORUM_COMMENT_DELETE,
	FORUM_COMMENT_REPLY,
} from '../forum/types'
import { APP_SHOW_ALERT, APP_HIDE_ALERT } from '../app/types'

const pollStatus= async (ctx, { thread_id}) => {
	try {
		const { data } = await post.stopPoll({ thread_id })
		ctx.commit(POST_POLL_STOP, data)
	} catch (e) {
		console.error(e)
	}
}


const getPollUsers = async (ctx, query = '') => {
	ctx.commit(POST_POLL_USERS_LOADING, true);
	try {
		const { data , headers} = await post.fetchPollsUser(query);
		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']
		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage
		}
		ctx.commit(POST_POLL_USERS, response);
	} catch (e) {
		console.error(e);
	} finally {
		ctx.commit(POST_POLL_USERS_LOADING, false);
	}
};


const getPollTimer = async (ctx) => {
	ctx.commit(POST_POLL_TIMER_LOADING, true)
	try {
		const { data } = await post.fetchTimerPoll()
		ctx.commit(POST_POLL_TIMER, data)
		ctx.commit(POST_POLL_TIMER_LOADING, false)
	} catch (e) {
		ctx.commit(POST_POLL_TIMER_LOADING, false)
		console.error(e)
	}
}

const fetchMyPosts = async (ctx) => {
	ctx.commit(POST_LOADING_STATUS, true)
	try {
		const { data } = await profile.fetchMyPosts()
		ctx.commit(POSTS_FETCH_BY_AUTHOR, data)
		ctx.commit(POST_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(POSTS_FETCH_BY_AUTHOR_ERROR, e)
		console.error(e)
	}
}

const fetchPostsByAuthor = async (ctx, id) => {
	ctx.commit(POST_LOADING_STATUS, true)
	try {
		const { data } = await profile.fetchPostByUser(id)
		ctx.commit(POSTS_FETCH_BY_AUTHOR, data)
		ctx.commit(POST_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(POSTS_FETCH_BY_AUTHOR_ERROR, e)
		console.error(e)
	}
}

const fetchPosts = async (ctx, filters) => {
	ctx.commit(POST_LOADING_STATUS, true)
	try {
		const { data, headers } = await post.fetchPosts(filters)
		const pageCount = headers['x-pagination-page-count']
		const response = { data, pageCount }
		ctx.commit(POSTS_FETCH, response, filters)
		ctx.commit(POST_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(POSTS_FETCH_ERROR, e)
		console.error(e)
	}
}

const fetchPostsByCategory = async (ctx, filters) => {
	ctx.commit(POST_LOADING_STATUS, true)
	try {
		const { data } = await post.fetchPosts(filters)
		ctx.commit(POSTS_FETCH_BY_CATEGORY, data, filters)
		ctx.commit(POST_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(POSTS_FETCH_BY_CATEGORY_ERROR, e)
		console.error(e)
	}
}

const getPost = async (ctx, postId) => {
	ctx.commit(POST_LOADING_STATUS, true)
	ctx.commit(POST_GET_ERROR_NOT_FOUND, false)
	try {
		const { data: postData } = await post.getPost(postId)
		const { data: postCommentData } = await post.getPostComments(postId)

		ctx.commit(POST_GET, postData)
		ctx.commit(POST_COMMENTS_GET, postCommentData)

		ctx.commit(POST_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(POST_LOADING_STATUS, false)
		ctx.commit(POST_GET_ERROR, e)
		ctx.commit(POST_GET_ERROR_NOT_FOUND, true)
		ctx.commit(POST_COMMENTS_GET_ERROR, e)

		console.error(e)
	}
}

const addPost = async (ctx, postData) => {
	try {
		ctx.commit(POST_UPDATE_STATUS, true)
		const { data } = await post.addPost(postData)
		ctx.commit(POST_ADD, data)
		ctx.commit(POST_ADD, postData)
		const credentials = JSON.parse(localStorage.getItem('settings')).dwh.value
		ctx.dispatch('settings/sendDwhAction', {
			credentials,
			payload: {
				category: 'Content',
				action: 'create_news_post',
				module: 'News Feed',
				session_id: ctx.rootGetters['app/sessionId'],
				version: process.env.VUE_APP_VERSION,
				platform: 'web app',
				login: credentials.login,
				data: data.thread_id,
				title: data.thread_title,
				chapter_id: [postData.chapter_id],
			},
		}, { root: true })
	} catch (e) {
		console.log(e)
		ctx.commit(POST_ADD_ERROR, e)
		throw e
	} finally {
		ctx.commit(POST_UPDATE_STATUS, false)
	}
}

const editPost = async (ctx, postData) => {
	try {
		ctx.commit(POST_UPDATE_STATUS, true)
		const { data } = await post.editPost(postData.id, postData.data)
		ctx.commit(POST_GET, data)
		const credentials = JSON.parse(localStorage.getItem('settings')).dwh.value
		ctx.dispatch('settings/sendDwhAction', {
			credentials,
			payload: {
				category: 'Content',
				action: 'edit_news_post',
				module: 'News Feed',
				session_id: ctx.rootGetters['app/sessionId'],
				version: process.env.VUE_APP_VERSION,
				platform: 'web app',
				login: credentials.login,
				data: data.thread_id,
				title: data.thread_title,
				chapter_id: [data.chapter_id],
			},
		}, { root: true })
	} catch (e) {
		console.log(e)
		ctx.commit(POST_ADD_ERROR, e)
		throw e
	} finally {
		ctx.commit(POST_UPDATE_STATUS, false)
	}
}

const removePost = async (ctx, id) => {
	try {
		ctx.commit(POST_UPDATE_STATUS, true)
		await post.removePost(id)
		const closeTimeout = setTimeout(() => {
			ctx.commit(`app/${APP_HIDE_ALERT}`, '', { root: true })
		}, 3000)
		ctx.commit(`app/${APP_SHOW_ALERT}`, { message: 'Post has been deleted', closeTimeout }, { root: true })
		return true
	} catch (e) {
		console.log(e)
		ctx.commit(POST_ADD_ERROR, e)
		return false
	} finally {
		ctx.commit(POST_UPDATE_STATUS, false)
	}
}

const updatePost = async (ctx, { postId, postData }) => {
	try {
		const { data } = await post.updatePost(postId, postData)
		ctx.commit(POST_UPDATE, data)
		ctx.commit(POST_UPDATE, postData)
	} catch (e) {
		ctx.commit(POST_UPDATE_ERROR, e)
		throw e
	}
}

const deletePost = async (ctx, postId) => {
	try {
		await post.deletePost(postId)
		ctx.commit(POST_DELETE, postId)
	} catch (e) {
		ctx.commit(POST_DELETE_ERROR, e)
		throw e
	}
}

const addComment = async (ctx, { commentBody, thread_title }) => {
	try {
		ctx.commit(POST_COMMENT_ADD_STATUS, true)
		const { data } = await comment.addComment(commentBody)

		ctx.commit(POST_COMMENT_ADD_STATUS, false)
		ctx.commit(POST_COMMENT_ADD, data)
		const credentials = JSON.parse(localStorage.getItem('settings')).dwh.value
		const currentPost = ctx.getters['post']
		const triggerPayload = {
			credentials,
			payload: {
				category: 'Content',
				action: 'click_send_comment_news_post',
				module: 'News Feed',
				session_id: ctx.rootGetters['app/sessionId'],
				version: process.env.VUE_APP_VERSION,
				platform: 'web app',
				login: credentials.login,
				data: data.thread_id,
				title: thread_title,
			},
		}

		if (currentPost && currentPost.chapter_id) {
			triggerPayload.payload.chapter_id = [currentPost.chapter_id]
		}

		ctx.dispatch('settings/sendDwhAction', triggerPayload, { root: true })
	} catch (e) {
		ctx.commit(POST_COMMENT_ADD_ERROR, e)
		throw e
	}
}

const addCommentEvent = async (ctx, commentData) => {
	ctx.commit(POST_EVENT_COMMENT_ADD_STATUS)
	try {
		const { data } = await comment.addEventComment(commentData)
		ctx.commit(POST_EVENT_COMMENT_ADD_STATUS, false)
		ctx.commit(POST_EVENT_COMMENT_ADD, data.data)
	} catch (e) {
		ctx.commit(POST_EVENT_COMMENT_ADD_ERROR, e)
		throw e
	}
}

const addReply = async (ctx, replyData) => {
	const { parent_id, thread_id, reply_text, isPost, thread_title } = replyData

	ctx.commit(POST_COMMENT_REPLY_STATUS, true)

	try {
		const { data } = await comment.addComment({ parent_id, thread_id, reply_text })

		ctx.commit(POST_COMMENT_REPLY_STATUS, false)

		ctx.commit(POST_COMMENT_REPLY, { payload: data, parentId: parent_id })
		ctx.commit(
			`forum/${FORUM_COMMENT_REPLY}`,
			{ payload: data, parentId: parent_id },
			{ root: true },
		)
		if (isPost) {
			const credentials = JSON.parse(localStorage.getItem('settings')).dwh.value
			const currentPost = ctx.getters['post']
			const triggerPayload = {
				credentials,
				payload: {
					category: 'Content',
					action: 'click_send_reply_news_post',
					module: 'News Feed',
					session_id: ctx.rootGetters['app/sessionId'],
					version: process.env.VUE_APP_VERSION,
					platform: 'web app',
					login: credentials.login,
					data: data.thread_id,
					title: thread_title,
				},
			}

			if (currentPost && currentPost.chapter_id) {
				triggerPayload.payload.chapter_id = [currentPost.chapter_id]
			}

			ctx.dispatch('settings/sendDwhAction', triggerPayload, { root: true })
		}
	} catch (e) {
		ctx.commit(POST_COMMENT_REPLY_ERROR, e)
		throw e
	}
}

const editComment = async (ctx, { commentId, commentData }) => {
	ctx.commit(POST_COMMENT_UPDATE_STATUS, true)
	try {
		const { data } = await comment.updateComment({ commentId, commentData })
		ctx.commit(POST_COMMENT_UPDATE_STATUS, false)
		ctx.commit(POST_COMMENT_UPDATE, data.data)
	} catch (e) {
		ctx.commit(POST_COMMENT_UPDATE_ERROR, e)
		throw e
	}
}

const deleteComment = async (ctx, commentData) => {
	ctx.commit(POST_COMMENT_DELETE_STATUS, true)
	try {
		await comment.deleteComment(commentData.id)

		ctx.commit(POST_COMMENT_DELETE_STATUS, false)

		ctx.commit(POST_COMMENT_DELETE, commentData)
		ctx.commit(
			`forum/${FORUM_COMMENT_DELETE}`,
			commentData,
			{ root: true },
		)
	} catch (e) {
		ctx.commit(POST_COMMENT_DELETE_ERROR, e)
		throw e
	}
}

const likeComment = async (ctx, commentData) => {
	try {
		const payloadData = {
			upvote: commentData.upvote,
			upvote_count: commentData.upvoteCount,
		}

		if (commentData.upvote === 0) {
			await comment.likeComment(commentData.id)

			payloadData.upvote = 1
			payloadData.upvote_count += 1
		}
		if (commentData.upvote === 1) {
			await comment.dislikeComment(commentData.id)

			payloadData.upvote = 0
			payloadData.upvote_count -= 1
		}

		ctx.commit(POST_COMMENT_LIKE, {
			comment: commentData,
			payloadData: payloadData,
		})

		ctx.commit(`forum/${FORUM_COMMENT_LIKE}`, {
			comment: commentData,
			payloadData: payloadData,
		}, { root: true })

	} catch (e) {
		ctx.commit(POST_COMMENT_LIKE_ERROR, e)
		throw e
	}
}

const deleteReply = async (ctx, { reply, parentComment }) => {
	ctx.commit(POST_COMMENT_REPLY_DELETE_STATUS, true)
	try {
		await comment.deleteComment(reply.id)
		ctx.commit(POST_COMMENT_REPLY_DELETE_STATUS, false)
		ctx.commit(POST_COMMENT_REPLY_DELETE, { reply, comment: parentComment })
	} catch (e) {
		ctx.commit(POST_COMMENT_REPLY_DELETE_ERROR, e)
		throw e
	}
}

const getNearbyPosts = async (ctx, coordinates) => {
	ctx.commit(POSTS_NEARBY_FETCH_LOADING, true)
	try {
		const { data } = await post.getNearbyLocationPosts(coordinates)
		ctx.commit(POSTS_NEARBY_FETCH_LOADING, false)
		ctx.commit(POSTS_NEARBY_FETCH, data)
	} catch (e) {
		ctx.commit(POSTS_NEARBY_FETCH_ERROR, e)
		throw e
	}
}

const getFeaturedPost = async (ctx, categoryId) => {
	ctx.commit(POST_FEATURED_LOADING, true)
	try {
		const { data } = await post.getFeaturedPost(categoryId)
		ctx.commit(POST_FEATURED_LOADING, false)
		ctx.commit(POST_FEATURED_GET, data.data)
	} catch (e) {
		ctx.commit(POST_FEATURED_LOADING, false)
		throw e
	}
}

const sendReport = async (ctx, { postId, reason }) => {
	ctx.commit(POST_REPORT_STATUS, true)
	try {
		await post.sendReport(postId, reason)
		ctx.commit(POST_REPORT_STATUS, true)
		ctx.commit(POST_REPORT, postId)
	} catch (e) {
		ctx.commit(POST_REPORT_ERROR, e)
		throw e
	}
}

const uploadFile = async (ctx, data) => {
	ctx.commit(POST_FILE_LOADING_STATUS, true)
	try {
		const { data: payload } = await post.uploadFile(data)
		ctx.commit(POST_UPLOAD_FILE, payload)
		ctx.commit(POST_FILE_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(POST_VIOLATIONS_GET_ERROR, e)
		ctx.commit(POST_FILE_LOADING_STATUS, false)
		throw e
	}
}

const getViolationsList = async (ctx) => {
	try {
		const { data } = await post.getViolationsList()
		ctx.commit(POST_VIOLATIONS_GET, data.data)
	} catch (e) {
		ctx.commit(POST_VIOLATIONS_GET_ERROR, e)
		throw e
	}
}


const votePoll = async (ctx, payload) => {
	try {
		const { poll } = payload
		ctx.commit(POST_POLL_VOTING, true)
		const { data } = await post.votePoll(poll)
		ctx.commit(POST_POLL_LIST_UPDATE, data)
		ctx.commit(POST_GET, data)
		return data
	} catch (e) {
		ctx.commit(POST_POLL_VOTING_ERROR, e)
		throw e
	} finally {
		ctx.commit(POST_POLL_VOTING, false)
	}
}


const videoUpload = async (ctx, data) => {
	ctx.commit(POST_VIDEO_PREVIEW_LOADING,true)
	try {
		const { data: payload } = await post.uploadVideo(data)
		ctx.commit(POST_VIDEO_PREVIEW, payload)
		ctx.commit(POST_VIDEO_PREVIEW_LOADING,false)
	} catch (e) {
		ctx.commit(POST_VIDEO_PREVIEW_ERROR, e)
		ctx.commit(POST_VIDEO_PREVIEW_LOADING,false)
		throw e
	}
}

export default {
	fetchPosts,
	getPost,
	addPost,
	updatePost,
	deletePost,
	addComment,
	fetchPostsByAuthor,
	editComment,
	deleteComment,
	addReply,
	deleteReply,
	getNearbyPosts,
	getFeaturedPost,
	sendReport,
	getViolationsList,
	fetchMyPosts,
	fetchPostsByCategory,
	addCommentEvent,
	uploadFile,
	likeComment,
	votePoll,
	editPost,
	removePost,
	getPollTimer,
	getPollUsers,
	pollStatus,
	videoUpload
}
